import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../config/ApiConfig';
import Layout from './components/Layout';
import ResponsiveShadow from './components/ResponsiveShadow';
import PageHeader from './components/PageHeader';
import PageContent from './components/PageContent';
import TableContainer from './components/TableContainer';
import TableHeader from './components/TableHeader';
import Pagination10 from './components/Pagination10';
import PageFooter from './components/PageFooter';
import usePagination10 from './components/hooks/usePagination10';

function SessionsAtivas() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const { setPagination } = usePagination10(sessions.length);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    const token = localStorage.getItem('token');
    axios.post(
      `${API_BASE_URL.LOGIN}/sessions/active`,
      null,
      { headers: { Authorization: `Bearer ${token}` } }
    )
      .then(res => {
        // Ordenar sessões pela hora de login (mais recente primeiro)
        const parseLoginTime = (s) => {
          const t = s?.loginTime ?? s?.LOGIN_TIME ?? s?.login_time ?? s?.LOGINTIME;
          if (Array.isArray(t) && t.length >= 6) {
            try {
              const [year, month, day, hour, minute, second] = t.map(v => Number(v));
              return new Date(year, (month || 1) - 1, day || 1, hour || 0, minute || 0, second || 0).getTime();
            } catch (e) {
              return 0;
            }
          }
          if (typeof t === 'string') {
            const parsed = Date.parse(t);
            return isNaN(parsed) ? 0 : parsed;
          }
          // fallback: try common numeric timestamp
          const num = Number(t);
          return isNaN(num) ? 0 : num;
        };

        const sorted = Array.isArray(res.data)
          ? res.data.slice().sort((a, b) => parseLoginTime(b) - parseLoginTime(a))
          : res.data;

        setSessions(sorted);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <Layout>
      <ResponsiveShadow>
        <PageHeader title="Sessões Ativas" icon="bi-list-task" closeRoute="/home" backButton={false} />
        <PageContent>
      {loading ? (
        <div>Carregando...</div>
      ) : sessions.length === 0 ? (
        <>
          <div className="alert alert-info">Nenhuma sessão ativa encontrada.</div>
        </>
      ) : (
        <>
          <TableContainer tableClass="table-custom-radius">
            <TableHeader columns={[
              { label: 'Nº', width: '5%' },
              { label: 'Login' },
              { label: 'Localização' },
              { label: 'Horário de Login', width: '15%' },
            ]} />
            <tbody>
              {sessions.slice(setPagination.startIndex, setPagination.startIndex + setPagination.rowsPerPage).map((sess, idx) => (
                <tr key={sess.id || sess.ID || Math.random()}>
                  <td style={{ width: '5%' }}>{setPagination.startIndex + idx + 1}</td>
                  <td>{sess.nome ?? sess.NOME ?? sess.login ?? sess.LOGIN ?? sess.cpf ?? sess.CPF ?? '-'}</td>
                  <td>{sess.location && typeof sess.location === 'string' && sess.location !== 'null, null, null' ? sess.location : '-'}</td>
                  <td style={{ width: '15%' }}>{Array.isArray(sess.loginTime) && sess.loginTime.length >= 6 && sess.loginTime.every(v => v !== undefined && v !== null) ? `${sess.loginTime[2].toString().padStart(2,'0')}/${sess.loginTime[1].toString().padStart(2,'0')}/${sess.loginTime[0]} ${sess.loginTime[3].toString().padStart(2,'0')}:${sess.loginTime[4].toString().padStart(2,'0')}:${sess.loginTime[5].toString().padStart(2,'0')}` : (sess.loginTime ?? sess.LOGIN_TIME ?? '-')}</td>
                </tr>
              ))}
            </tbody>
          </TableContainer>
        </>
      )}
        </PageContent>
        <PageFooter>
            <Pagination10 {...setPagination} />
          </PageFooter>
      </ResponsiveShadow>
    </Layout>
  );
}

export default SessionsAtivas;
